
export default {
  props: {
    icon: {type: String, default: undefined},
    children: {type: Number, default: 0},
    level: {type: Number, default: 0},
    title: {type: String, required: true},
    active: {type: Boolean, default: false},
    opened: {type: Boolean, default: false},
    store: {type: Object, default: undefined},
  },
  emits: ['arrow'],

}
